import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["feedback"]
  static values = { sortUrl: String }

  connect() {
    this.initializeSortables()
  }

  initializeSortables() {
    const sortableLists = this.element.querySelectorAll('.sortable-list')
    
    sortableLists.forEach(list => {
      new Sortable(list, {
        animation: 150,
        handle: '.cursor-move',
        ghostClass: 'bg-gray-100',
        chosenClass: 'bg-gray-50',
        dragClass: 'opacity-50',
        onEnd: (event) => this.handleSort(event)
      })
    })
  }

  async handleSort(event) {
    const tbody = event.target
    const items = tbody.querySelectorAll('.sortable-item')
    const perkIds = Array.from(items).map(item => item.dataset.perkId)
    
    // 表示順の番号を即座に更新
    this.updatePositionNumbers(tbody)
    
    try {
      const response = await fetch(this.sortUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Accept': 'application/json'
        },
        body: JSON.stringify({ perk_ids: perkIds })
      })
      
      const data = await response.json()
      
      if (response.ok) {
        this.showFeedback('success', data.message)
      } else {
        // エラー時は元の位置に戻す
        this.revertSort(event)
        this.showFeedback('error', data.message || '並び順の更新に失敗しました')
      }
    } catch (error) {
      // ネットワークエラー時も元の位置に戻す
      this.revertSort(event)
      this.showFeedback('error', 'ネットワークエラーが発生しました')
    }
  }

  updatePositionNumbers(tbody) {
    const items = tbody.querySelectorAll('.sortable-item')
    items.forEach((item, index) => {
      const positionCell = item.querySelector('.position-cell')
      if (positionCell) {
        positionCell.textContent = index + 1
      }
    })
  }

  revertSort(event) {
    const { item, oldIndex, newIndex } = event
    const tbody = event.target
    const items = Array.from(tbody.children)
    
    // 元の位置に戻す
    if (oldIndex < newIndex) {
      tbody.insertBefore(item, items[oldIndex])
    } else {
      tbody.insertBefore(item, items[oldIndex + 1] || null)
    }
    
    // 表示順の番号を再更新
    this.updatePositionNumbers(tbody)
  }

  showFeedback(type, message) {
    const feedbackElement = this.feedbackTarget
    
    // スタイルクラスを設定
    feedbackElement.className = 'fixed bottom-4 right-4 p-4 rounded-md shadow-lg transition-opacity duration-300'
    
    if (type === 'success') {
      feedbackElement.classList.add('bg-green-500', 'text-white')
      feedbackElement.innerHTML = `
        <div class="flex items-center">
          <i class="fa-solid fa-check-circle mr-2"></i>
          <span>${message}</span>
        </div>
      `
    } else {
      feedbackElement.classList.add('bg-red-500', 'text-white')
      feedbackElement.innerHTML = `
        <div class="flex items-center">
          <i class="fa-solid fa-exclamation-circle mr-2"></i>
          <span>${message}</span>
        </div>
      `
    }
    
    // 表示
    feedbackElement.classList.remove('hidden', 'opacity-0')
    feedbackElement.classList.add('opacity-100')
    
    // 3秒後に非表示
    setTimeout(() => {
      feedbackElement.classList.remove('opacity-100')
      feedbackElement.classList.add('opacity-0')
      setTimeout(() => {
        feedbackElement.classList.add('hidden')
      }, 300)
    }, 3000)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}